import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {bbFindUserTagsByTagId, isCurrentUserMemberOf} from "../../../util/bbHelpers";
import {Tooltip} from "@material-ui/core";
import ComingSoonIconSettings from "./ComingSoonIconSettings";
import {removeTagsForToursNew, removeTagsForToursTutorial} from "../../../actions";
import {indexOfTours} from "../../../containers/ProductTours/indexOfTours";

const TipandToursRadio = ({customer=null}) => {

    const authUser = useSelector(({auth}) => auth.authUser);
    // const {loadingAddTag, loadingAddTagError, loadingUpdateTag, loadingUpdateTagError} = useSelector(({breachrisk})=> breachrisk);
    const dispatch = useDispatch();
    const isAdmin = isCurrentUserMemberOf(authUser,"admin");
    const isStaff = isCurrentUserMemberOf(authUser, "staff");

    const isDisabled = true;
    const textColor = isDisabled ? "text-light-gray" : "";
    const toursTagsTutorial = bbFindUserTagsByTagId(authUser, 61);
    const tourTagsNew = bbFindUserTagsByTagId(authUser, 62);

    const allTutorialTours = Object.values(indexOfTours).filter((tour)=> tour.type === "tutorial");


    const handleOnClick = (value) => {
        setSelected(value)
        // dispatch(removeTagsForToursTutorial())
        if(selected === "enable"){
            if(toursTagsTutorial.length > 0 && toursTagsTutorial.length){

            }

        } else if (selected === "disable"){

        }
    }

    //if there are zero tags of this type, then tours will start again (tags are added when tours are completed or dismissed)
    const [selected, setSelected] = useState(null);

    //TODO: this feature should be able to re-enable existing tutorial tours. Can't opt out of tours intitiall, should only be an available feature if torus have been taken.
    //what is the negative of that? should they be able to turn off all tours even if they haven' ttaken them??
    //if this is for tutorial tours.. what do we do for new product ones? Do those just always exist???
    return(
            <div className={`row ${textColor}`}>
                <Tooltip title={"Re-enable all tours and tips. Enabling will re-prompt you for each tour throughout the application."}>
                    <>
                        <p className={"col-5 text-right align-self-center"}>Tours and Tips:</p>
                        <p className={"col-1"}> </p>
                        <div className={"col-5 text-left"}>
                            <form className={"m-0 p-0 d-inline"}>
                                <div className={"col-6 d-inline m-0 p-0"}>
                                    <input type="radio"
                                           id="enable"
                                           name={"enable"}
                                           value={"enable"}
                                           disabled={isDisabled}
                                           checked={selected === "enable"}
                                           onClick={(e)=>handleOnClick(e.target.value)}
                                    />
                                    <label htmlFor="darkMode">&nbsp; Enable</label>
                                </div>
                                <div className={"col-6 d-inline"}>
                                    <input type="radio"
                                           id="disable"
                                           name={"disable"}
                                           value={"disable"}
                                           disabled={isDisabled}
                                           checked={selected === "disable"}
                                           onClick={(e)=>handleOnClick(e.target.value)}
                                    />
                                    <label htmlFor="lightMode">&nbsp; Disable</label>
                                </div>
                            </form>
                        </div>
                    </>
                </Tooltip>
                {isDisabled && <ComingSoonIconSettings className={"align-self-center mb-1 pb-1"}/>}

            </div>

    )
}

export default TipandToursRadio;